class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      {
        once: true,
      }
    );
    document.body.classList.add('overflow-hidden');
  }
  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    const parsedHTML = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');

    const isEmpty = parsedHTML.querySelector('cart-drawer')?.classList.contains('is-empty');
    this.classList.toggle('is-empty', isEmpty);
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('cart-drawer', CartDrawer);
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);
/*
class DonationProducts extends HTMLElement {
  constructor() {
    super();
    this.state = {
      value: null,
      cartData: null,
      selectedDonation: null,
      isSubmitting: false,
    };
    this.selectOptions = [];
    this.donationVariants = {};
    this.boundCheckout = null;
    this.checkoutButton = null;
  }
  connectedCallback() {
    this.selectOptions = this.getSelectOptions();
    this.donationVariants = this.parseDonationVariants();
    this.init();
  }
  disconnectedCallback() {
    if (this.checkoutButton && this.boundCheckout) {
      this.checkoutButton.removeEventListener('click', this.boundCheckout);
      this.checkoutButton = null;
      this.boundCheckout = null;
    }
  }
  getSelectOptions() {
    return [...this.querySelectorAll('input[name="donation-option"]')].map((input) => {
      const label = this.querySelector(`label[for="${input.id}"]`);
      const image = label?.querySelector('img');
      return {
        title: input.value,
        available: true,
        image: image ? image.src : null,
      };
    });
  }
  parseDonationVariants() {
    const script = this.querySelector('.donation-variants');
    if (!script) return {};
    return JSON.parse(script.textContent);
  }
  getInputs() {
    return this.querySelectorAll('input[name="donation-option"]');
  }
  async fetchCart() {
    return fetch('/cart.js').then((res) => res.json());
  }
  getCartItems() {
    return this.state.cartData?.items || [];
  }
  getSubscriptionItems() {
    return this.getCartItems().filter((item) => {
      return item.selling_plan_allocation && item.handle !== 'free-donations';
    });
  }
  hasNonDonationItems() {
    return this.getCartItems().some((item) => {
      return item.handle !== window.cartStrings.donation_product;
    });
  }
  select(option) {
    this.state.value = option;
    this.state.selectedDonation = this.getSelectedDonation();

    // this.updateUI();
  }
  getSelectedDonation() {
    if (!this.state.value) return null;
    const variants = this.donationVariants[this.state.value.title];

    if (!variants) return null;
    const subscriptionItems = this.getSubscriptionItems();
    if (!subscriptionItems.length) {
      return variants.find((v) => v.months == null) || null;
    }
    const sellingPlan = subscriptionItems[0].selling_plan_allocation.selling_plan;

    const option = sellingPlan.options[0];
    const match = option.value.match(/(\d+)/);
    const months = match ? Number(match[1]) : null;

    const variant = variants.find((v) => Number(v.months) === Number(months));

    return variant || null;
  }
  async clearCartDonations(shouldRerender = false) {
    const cart = await this.fetchCart();

    const donationItems = cart.items.filter((item) => {
      return item.handle === window.cartStrings.donation_product;
    });

    if (!donationItems.length) {
      return;
    }
    const updates = {};
    donationItems.forEach((item) => {
      updates[item.key] = 0;
    });
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates,
        sections: ['cart-drawer', 'cart-icon-bubble', 'donation-products'],
      }),
    })
      .then((res) => res.json())
      .then((parsedState) => {
        if (shouldRerender) {
          const drawer = document.querySelector('cart-drawer');
          if (drawer) drawer.renderContents(parsedState);
        }
      });
  }
  async rerenderDrawer() {
    if (DonationProducts._rerendering) return;
    DonationProducts._rerendering = true;
    try {
      const response = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      const sections = await response.json();
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      drawer.renderContents({
        sections,
      });
    } finally {
      setTimeout(() => {
        DonationProducts._rerendering = false;
      }, 0);
    }
  }
  async updateDonations() {
    this.state.cartData = await this.fetchCart();
    if (!this.hasNonDonationItems()) {
      await this.clearCartDonations(true);
      return;
    }
    await this.clearCartDonations(false);
    this.state.selectedDonation = this.getSelectedDonation();
    if (!this.state.selectedDonation) { 
      console.warn("[Donation] no matching donation");
      window.location.href = "/checkout";
      return;
    }
    const subscriptionItems = this.getSubscriptionItems();
    const originalSellingPlanId = subscriptionItems.length
      ? subscriptionItems[0].selling_plan_allocation?.selling_plan?.id
      : null;
    const donationSellingPlanId = this.state.selectedDonation.selling_plan;
    const payload = {
      items: [
        {
          id: this.state.selectedDonation.id,
          quantity: 1,
          ...(donationSellingPlanId && {
            selling_plan: donationSellingPlanId,
          }),
          properties: {
            _selling_plan_id: originalSellingPlanId ? String(originalSellingPlanId) : '',
          },
        },
      ],
      sections: ['cart-drawer', 'cart-icon-bubble', 'donation-products'],
    };

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const parsedState = await response.json();
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.renderContents(parsedState);
      location.href = '/checkout';
    } catch (error) {
      console.error('[Donation] add failed', error);
    }
  }
  setCheckoutButtonLoadingState(value) {
    if (!this.checkoutButton) return;
    const spinner = this.checkoutButton.querySelector('.loading__spinner');
    if (value) {
      this.checkoutButton.classList.add('loading');
      this.checkoutButton.setAttribute('aria-disabled', true);
      this.checkoutButton.disabled = true;
      if (spinner) spinner.classList.remove('hidden');
    } else {
      this.checkoutButton.classList.remove('loading');
      this.checkoutButton.setAttribute('aria-disabled', false);
      this.checkoutButton.disabled = false;
      if (spinner) spinner.classList.add('hidden');
    }
  }
  async checkout(event) {
    event.preventDefault();
    if (this.state.isSubmitting) return;
    this.state.isSubmitting = true;
    this.setCheckoutButtonLoadingState(true);
    try {
      await this.updateDonations();
    } catch (error) {
      console.error(error);
    } finally {
      this.state.isSubmitting = false;
      this.setCheckoutButtonLoadingState(false);
    }
  }
  bindEvents() {
    this.getInputs().forEach((input) => {
      input.addEventListener('change', () => {
        const option = this.selectOptions.find((opt) => opt.title === input.value);
        if (option) this.select(option);
      });
    });
    this.checkoutButton = document.querySelector('#CartDrawer-Checkout');
    if (this.checkoutButton) {
      if (this.boundCheckout) {
        this.checkoutButton.removeEventListener('click', this.boundCheckout);
      }
      this.boundCheckout = this.checkout.bind(this);
      this.checkoutButton.addEventListener('click', this.boundCheckout);
    }
  }
  setDefaultSelection() {
    const firstOption = this.selectOptions[0];
    if (!firstOption) return;
    this.select(firstOption);
  }
  async init() {
    if (DonationProducts._rerendering) return;
    this.state.cartData = await this.fetchCart();
    const hasRealItems = this.state.cartData.items.some((item) => item.handle !== window.cartStrings.donation_product);
    if (!hasRealItems) {
      const hasDonations = this.state.cartData.items.some(
        (item) => item.handle === window.cartStrings.donation_product
      );
      if (hasDonations) {
        await this.clearCartDonations(false);
        await this.rerenderDrawer();
      }
      return;
    }
    this.bindEvents();
    this.setDefaultSelection();
  }
}
DonationProducts._rerendering = false;
if (!customElements.get('donation-products')) {
  customElements.define('donation-products', DonationProducts);
}
*/
if (!customElements.get('upsell-product-form')) {
  customElements.define(
    'upsell-product-form',
    class UpsellProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      async onSubmitHandler(event) {
        event.preventDefault();
        if (this.submitButton?.getAttribute('aria-disabled') === 'true') {
          return;
        }
        const spinner = this.querySelector('.loading__spinner');
        const upsellCartBtn = this.querySelector('.upsell-cart-btn');
        try {
          spinner?.classList.remove('hidden');
          upsellCartBtn?.style.setProperty('opacity', '0');
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          const response = await fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
          });
          const parsedState = await response.json();
          const drawer = document.querySelector('cart-drawer');
          if (drawer) {
            drawer.renderContents(parsedState);
          }
        } catch (error) {
          console.error('[UpsellProductForm]', error);
        } finally {
          spinner?.classList.add('hidden');
          upsellCartBtn?.style.setProperty('opacity', '1');
        }
      }
    }
  );
}
